import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from '../../shared/services/http.service';
import { SiteId } from '../../site-detail/models/Site';
import { VideoCall, VideoCallId } from '../models/video-call';

import { VideoCallGateway } from './VideoCallGateway';

@Injectable()
export class HttpVideoCallGateway implements VideoCallGateway {
    constructor(private httpService: HttpService) {}

    startVideoCall(siteId: SiteId): Observable<VideoCall> {
        return this.httpService
            .post(`/v1/video-call/${siteId}`, {})
            .pipe(map((videoCall) => ({ ...videoCall, siteId })));
    }

    stopVideoCall(siteId: SiteId): Observable<void> {
        return this.httpService.delete(`/v1/video-call/${siteId}`);
    }

    getVideoCalls(): Observable<VideoCall[]> {
        return this.httpService.get(`/v1/video-calls`);
    }

    resendVideoCallInvitation(videoCallId: VideoCallId): Observable<VideoCall> {
        return this.httpService.post(`/v1/video-call-resend/${videoCallId}`, {});
    }
}
